import * as echarts from 'echarts';
import { useEffect, useRef } from "react";
import { colorOfYAxis } from '../constants';

interface IProps {
    xAxis: any
    yArea: any
    yLine: any
    series: any
}

const ChartDiseases: React.FC<IProps> = (props) => {
    const areaRef = useRef<HTMLDivElement>(null);
    const { xAxis = {}, yArea, yLine, series } = props;

    useEffect(() => {
        if (areaRef.current) {
            const existInstance = echarts.getInstanceByDom(areaRef.current)
            if (existInstance) echarts.dispose(areaRef.current)
            if (Object.keys(yLine).length)
                areaRef.current.style.height = `${Object.keys(yArea).length * 12 + 28}px`;
            const chart = echarts.init(areaRef.current)
            let i = 0;
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: { width: 0 }
                    }
                },
                grid: {
                    height: Object.keys(yArea).length * 12,
                    top: '28px',
                    right: '20px',
                    bottom: 0,
                },
                xAxis: {
                    ...xAxis,
                    show: false,
                },
                yAxis: [
                    {
                        type: 'category',
                        lineHeight: 28,
                        axisLabel: { show: false },
                        axisTick: { show: false },
                        axisLine: { show: false, },
                        data: Object.keys(yArea).map(key => key),
                    },
                    ...Object.keys(yLine).map((key) => {
                        const value = {
                            type: 'value',
                            name: key,
                            position: 'left',
                            offset: colorOfYAxis[key] ? (50 * i) : 0,
                            alignTicks: true,
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: colorOfYAxis[key]
                                }
                            },
                        }
                        if (colorOfYAxis[key])
                            i++;
                        return value
                    })
                ],
                series
            };
            chart.setOption(option, true);
        }
    }, [series, xAxis, yLine, yArea])

    return <div ref={areaRef} style={{ height: '28px', width: '100%', marginBottom: '-5px' }} />
}

export default ChartDiseases